export default class UnexpectedNetworkError extends Error {}
